<template>
  <div class="practice">
    <div class="practice-bar">
      <label>Dinleme hızı <select v-model.number="speed" @change="applySpeed"><option :value="0.75">0,75×</option><option :value="1">Normal</option><option :value="1.25">1,25×</option></select></label>
      <div class="practice-actions">
        <button type="button" :disabled="!hasAudio" @click="toggleAll">{{ mode === 'all' ? (paused ? 'Devam et' : 'Duraklat') : 'Tüm Diyaloğu Dinle' }}</button>
        <slot name="language"></slot>
      </div>
    </div>
    <p v-if="message" role="status" class="hint">{{ message }}</p>
    <audio ref="sample" preload="none" @ended="ended" @error="mediaError"></audio>
  </div>
</template>
<script>
export default {
  name: 'DialogPractice',
  props: { dialogs: {type: Array, default: () => []} },
  emits: ['active'],
  data() { return { speed: 1, mode: '', paused: false, index: -1, message: '', generation: 0 }; },
  computed: {
    hasAudio() { return this.dialogs.some(d => d.audio); }
  },
  methods: {
    applySpeed() { if (this.$refs.sample) this.$refs.sample.playbackRate = this.speed; },
    stop() {
      this.generation++;
      this.$refs.sample?.pause();
      this.mode = ''; this.paused = false; this.index = -1;
      this.$emit('active', null);
    },
    async play(index) {
      const dialog = this.dialogs[index];
      if (!dialog?.audio) return;
      const token = ++this.generation;
      this.index = index; this.$emit('active', index);
      const audio = this.$refs.sample;
      audio.src = process.env.VUE_APP_ROOT_API + 'Source/dictionary/bookdialogaudio?fileName=' + encodeURIComponent(dialog.audio);
      this.applySpeed();
      try { await audio.play(); }
      catch (error) {
        if (token !== this.generation || error?.name === 'AbortError') return;
        this.stop(); this.message = 'Ses açılamadı. Yeniden deneyebilirsiniz.';
      }
    },
    playSingle(index) {
      if (this.mode === 'single' && this.index === index) { this.stop(); return; }
      this.stop(); this.message = ''; this.mode = 'single'; this.play(index);
    },
    async toggleAll() {
      this.message = '';
      if (this.mode === 'all') {
        if (!this.paused) { this.paused = true; this.$refs.sample.pause(); }
        else {
          this.paused = false;
          const token = this.generation;
          try { await this.$refs.sample.play(); }
          catch (error) { if (token === this.generation && error?.name !== 'AbortError') this.mediaError(); }
        }
        return;
      }
      this.stop(); this.mode = 'all'; this.advance();
    },
    advance() {
      this.generation++;
      for (let i = this.index + 1; i < this.dialogs.length; i++) {
        if (this.dialogs[i].audio) { this.play(i); return; }
      }
      this.stop(); this.message = 'Diyalog tamamlandı.';
    },
    ended() { if (this.mode === 'all') this.advance(); else this.stop(); },
    mediaError() { if (!this.mode) return; this.stop(); this.message = 'Ses yüklenemedi. Yeniden deneyebilirsiniz.'; }
  },
  watch: { dialogs() { this.stop(); this.message = ''; } },
  beforeUnmount() { this.stop(); }
};
</script>
<style scoped>
.practice { border-bottom: 1px solid #e2e8f0; padding-bottom: 20px; font-size: 14px; }
.practice-bar { display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 12px; }
.practice-bar label { display: flex; align-items: center; gap: 12px; margin: 0; }
.practice-actions { display: flex; align-items: center; justify-content: flex-end; gap: 12px; margin-left: auto; }
button, select { min-height: 44px; background: white; border: 1px solid #d8e5dd; border-radius: 9px; color: var(--brand-primary-hover); padding: 8px 12px; font: inherit; }
button { cursor: pointer; }
button:hover:not(:disabled) { background: #ecfdf5; }
button:disabled { opacity: .5; cursor: not-allowed; }
button:focus-visible, select:focus-visible { outline: 3px solid var(--brand-primary-hover); outline-offset: 2px; }
.hint { color: #64748b; margin: 12px 0 0; line-height: 1.6; }
@media(max-width: 575px) {
  .practice-bar { align-items: stretch; flex-direction: column; gap: 12px; padding: 14px; background: #f8faf9; border: 1px solid #e2e8f0; border-radius: 12px; }
  .practice-bar label { flex-direction: column; align-items: stretch; min-width: 0; gap: 8px; }
  .practice-bar label { font-size: 13px; }
  .practice-actions { justify-content: space-between; width: 100%; min-width: 0; margin-left: 0; gap: 8px; }
  .practice-bar select, .practice-actions > button { box-sizing: border-box; min-width: 0; max-width: 100%; font-size: 13px; line-height: 1.4; }
  .practice-bar select { width: 100%; }
  .practice-bar select {
    appearance: none;
    -webkit-appearance: none;
    font-size: 13px !important;
    height: 44px;
    padding-right: 36px;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 12px center;
    background-size: 16px;
  }
  .practice-bar button { font-weight: 600; }
}
</style>
